import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/form-field';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-add-unite',
    templateUrl: './modal-add-unite.component.html',
    styleUrls: ['./modal-add-unite.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatLabel, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalAddUniteComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalAddUniteComponent>>(MatDialogRef);

    public form: FormGroup;
    public formSubmitAttempt: boolean;

    constructor() {}

    // ---------------------------------------------------
    // CREATE FORM
    //
    createForm() {
        this.form = new FormGroup({
            titre: new FormControl<string>('', [Validators.required]),
            code: new FormControl<string>('', [Validators.required]),
        });
    }

    get titre() {
        return this.form.get('titre');
    }
    get code() {
        return this.form.get('code');
    }

    // ---------------------------------------------------
    // SAVE LABEL
    //
    prepareForSave() {
        this.formSubmitAttempt = true;
        if (this.form.valid) {
            const data = {
                titre: this.titre.value,
                code: this.code.value,
            };
            this.dialogRef.close(data);
        }
    }

    // ---------------------------------------------------
    // CANCEL FORM
    //
    public cancelForm() {
        this.formSubmitAttempt = false;
    }

    // ---------------------------------------------------
    // INIT
    //
    ngOnInit() {
        this.createForm();
    }
}
